import React from 'react';
import './CDCCTV.css';

function CDCCTV() {

    return (
        <main id="CDCCTV">
            <section id="CDCC-c1">
                <h2>CCTV – Soluciones de Videovigilancia</h2>
                <ul>
                    <li>Inicio</li>
                    <li>/</li>
                    <li>Servicios</li>
                    <li>/</li>
                    <li>CCTV – Soluciones de Videovigilancia</li>
                </ul>
            </section>
            <section id="CDCC-c2">
                <figure id="CDCC-c2__image">
                    <img src="/banner-service-01.jpg" alt="Instalación de cámaras de seguridad" />
                </figure>
                <div id="CDCC-c2__text">
                    <h4>En <strong>INFRASOL</strong> ofrecemos soluciones integrales de <strong>CCTV y videovigilancia</strong> diseñadas para proteger tus instalaciones.</h4>
                    <p>Con tecnología de punta de marcas líderes como Hikvision, Dahua y EZVIZ, te ayudamos a implementar sistemas de seguridad eficientes, escalables y fáciles de operar. Nuestros servicios cubren todo el ciclo de vida de un sistema de CCTV: diseño, suministro, instalación, configuración, puesta en marcha y soporte continuo.</p>
                </div>
            </section>
            <section id="CDCC-c3">
                <div id="CDCC-c3__text">
                    <h2>¿Por qué implementar un sistema de <strong>CCTV?</strong></h2>
                    <p>Los sistemas de videovigilancia ofrecen beneficios clave para tu organización:</p>
                    <ul id="CDCC-c3__beneficios">
                        <li>Prevención de robos y actos vandálicos</li>
                        <li>Monitoreo en tiempo real de zonas críticas</li>
                        <li>Registro de eventos con evidencia visual</li>
                        <li>Integración con sistemas de control de acceso y alarmas</li>
                        <li>Acceso remoto desde dispositivos móviles o PC</li>
                        <li>Mejora en la seguridad operativa y cumplimiento de normativas</li>
                    </ul>
                </div>
                <div id="CDCC-c3__image">
                    <figure>
                        <img src="/nota1.jpg" alt="Monitoreo de cámaras de seguridad" />
                    </figure>
                </div>
            </section>
            <section id="CDCC-c4">
                <h2>Servicios que ofrecemos</h2>
                <div id="CDCC-c4__servicios">
                    <div className="CDCC-c4__servicio">
                        <h3>Diseño de sistemas de CCTV</h3>
                        <p>Realizamos estudios de cobertura para definir:</p>
                        <ul>
                            <li>Cantidad y tipo de cámaras necesarias</li>
                            <li>Ángulos de visión y distancias de captura</li>
                            <li>Zonas de interés y puntos críticos</li>
                            <li>Tipo de almacenamiento requerido (DVR/NVR/Cloud)</li>
                        </ul>
                        <p>El diseño se basa en las mejores prácticas de seguridad y eficiencia operativa.</p>
                    </div>
                    <div className="CDCC-c4__servicio">
                        <h3>Suministro de equipos</h3>
                        <p>Proveemos equipos de marcas líderes con alto rendimiento y garantía, incluyendo:</p>
                        <ul>
                            <li>Cámaras Analógicas y HD-TVI</li>
                            <li>Cámaras IP de alta resolución</li>
                            <li>Cámaras PTZ (movimiento horizontal/vertical con zoom)</li>
                            <li>Cámaras térmicas y especializadas</li>
                            <li>Cámaras con visión nocturna y detección inteligente</li>
                        </ul>
                        <p>Trabajamos con Hikvision, Dahua y EZVIZ, marcas reconocidas por calidad, fiabilidad y soporte técnico.</p>
                    </div>
                    <div className="CDCC-c4__servicio">
                        <h3>Instalación y configuración</h3>
                        <p>Nuestro equipo realiza la instalación profesional de:</p>
                        <ul>
                            <li>Cámaras en interiores y exteriores</li>
                            <li>Tuberías y soportes estructurales</li>
                            <li>Cableado estructurado y gestión de energía</li>
                            <li>Configuración de parámetros de captura y grabación</li>
                        </ul>
                        <p>Además, configuramos:</p>
                        <ul>
                            <li>DVR (Digital Video Recorder)</li>
                            <li>NVR (Network Video Recorder)</li>
                            <li>Almacenamiento local y en red</li>
                            <li>Acceso remoto seguro desde móvil o PC</li>
                        </ul>
                    </div>
                    <div className="CDCC-c4__servicio">
                        <h3>Integración y servicios avanzados</h3>
                        <p>Los sistemas CCTV pueden integrarse con:</p>
                        <ul>
                            <li>Control de acceso</li>
                            <li>Alarmas y sensores</li>
                            <li>Detección inteligente (line crossing, intrusión, conteo de personas)</li>
                            <li>Análisis de video y estadísticas</li>
                        </ul>
                        <p>Esto permite automatizar respuestas ante eventos y mejorar la gestión de seguridad.</p>
                    </div>
                    <div className="CDCC-c4__servicio">
                        <h3>Configuración avanzada</h3>
                        <p>Nuestros especialistas configuran:</p>
                        <ul>
                            <li>Resolución y FPS según uso y almacenamiento</li>
                            <li>Alertas por movimiento o eventos inteligentes</li>
                            <li>Acceso remoto seguro con apps móviles</li>
                            <li>Copias de seguridad programadas</li>
                            <li>Roles y permisos de usuarios</li>
                        </ul>
                        <p>Esta configuración asegura un sistema intuitivo, seguro y optimizado según la operación de tu empresa.</p>
                    </div>
                </div>
            </section>
            <section id="CDCC-c5">
                <div id="CDCC-c5__image">
                    <figure>
                        <img src="/X86-H-265-Architecture-Embedded-Linux-Based-Security-Camera-Super-NVR.avif" alt="Sala de monitoreo CCTV" />
                    </figure>
                </div>
                <div id="CDCC-c5__text">
                    <h2>Tipos de grabación</h2>
                    <div id="CDCC-c5__tipos">
                        <div className="CDCC-c5__tipo">
                            <h4>DVR</h4>
                            <p>Digital Video Recorder para sistemas analógicos y HD-TVI. Ideal para instalaciones que requieren grabación local con múltiples canales.</p>
                        </div>
                        <div className="CDCC-c5__tipo">
                            <h4>NVR</h4>
                            <p>Network Video Recorder para sistemas IP. Permite gestión centralizada de cámaras IP a través de la red, con mayor flexibilidad y escalabilidad.</p>
                        </div>
                        <div className="CDCC-c5__tipo">
                            <h4>Cloud</h4>
                            <p>Almacenamiento en la nube para respaldo y acceso remoto. Ideal para empresas que requieren acceso desde múltiples ubicaciones y respaldo automático.</p>
                        </div>
                    </div>
                    <p><strong>¿Necesitas una cotización?</strong> Para cualquier solicitud de cotización o asesoría, contáctanos a través del botón de WhatsApp o mediante el menú Contacto.</p>
                </div>
            </section>
        </main>
    );
}

export default CDCCTV;
